module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break c"
  }), _vm._v(" "), _c('p', {
    staticClass: "title z"
  }, [_c('b', [_vm._v("THE OKLAHOMA "), _c('br'), _vm._v("\nPREPPER")])]), _vm._v(" "), _c('p', {
    staticClass: "title1 d"
  }, [_c('b', [_vm._v("Your Ultimate Survival Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "title2 c"
  }, [_c('b', [_vm._v("Matthew E. Sheets")])]), _vm._v(" "), _c('p', {
    staticClass: "image z"
  }, [_c('img', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "alt": "logo.jpg",
      "src": "html/images/logo.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "title3 z"
  }, [_c('a', {
    attrs: {
      "href": "http://www.TotalPublishingAndMedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TotalPublishingAndMedia.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-140280e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/01_title.vue
// module id = 57
// module chunks = 0